module.exports = __webpack_public_path__ + "img/p158.5a7baf02.png";